import { useIntl } from "react-intl"
import { useState } from "react"
import { Button } from "primereact/button"
import { classNames } from "primereact/utils"
import HistoricBillHospitalizationView from "./HistoricBillHospitalizationView"
import CRUHospitalizationBillView from "./CRUHospitalizationBillView"
import './Budget.scss'
import { BudgetDTO, defaultBudgetDTO } from "../../dto/budget/BudgetDTO"
import { EBudgetGridOptions, EBudgetGridOptionsValues } from "../../enums/EBudgetGridOptions"
import BillHospitalizationPreview from "./BillHospitalizationPreview"
import React from "react"
import PreinvoiceFromBillHospitalizationView from "./PreinvoiceFromBillHospitalizationView"
import PrintBillHospitalizationModal from "./PrintBillHospitalizationModal"
import BillHospitalizationOrdersView from "./BillHospitalizationOrdersView"

export default function HospitalizationBillView() {

    const intl = useIntl();
    const [tabIndex, setTabIndex] = useState<number>(2);
    const [selectedAction, setSelectedActionConst] = useState<number>(-1);
    const [selectedBudget, setSelectedBudget] = useState<BudgetDTO>(defaultBudgetDTO);
    const [openPrintBudgetModal, setOpenPrintBudgetModal] = useState<boolean>(false);

    const showNewBudgetButton = (tabIndex === 2) && (
        selectedAction !== EBudgetGridOptionsValues[EBudgetGridOptions.CREATE] &&
        selectedAction !== EBudgetGridOptionsValues[EBudgetGridOptions.EDIT] &&
        selectedAction !== EBudgetGridOptionsValues[EBudgetGridOptions.DUPLICATE]
    );

    const showCRUBudget = (
        selectedAction === EBudgetGridOptionsValues[EBudgetGridOptions.CREATE] ||
        selectedAction === EBudgetGridOptionsValues[EBudgetGridOptions.EDIT] ||
        selectedAction === EBudgetGridOptionsValues[EBudgetGridOptions.DUPLICATE]
    );

    const setSelectedAction = (action: number) => {
        setSelectedActionConst(action);
        if (
            action === EBudgetGridOptionsValues[EBudgetGridOptions.CREATE] ||
            action === EBudgetGridOptionsValues[EBudgetGridOptions.EDIT] ||
            action === EBudgetGridOptionsValues[EBudgetGridOptions.DUPLICATE]
        ) {
            setTabIndex(1);
            return;
        }
        setTabIndex(2);
    };

    const onCloseCRUBudgetView = () => {
        setSelectedBudget(defaultBudgetDTO);
        setSelectedActionConst(-1);
        setTabIndex(2);
    };

    // El alta/edición, la vista previa, la generación de la orden y las órdenes generadas usan el design system Novarium (su propio contenedor).
    const usesNovarium = showCRUBudget ||
        selectedAction === EBudgetGridOptionsValues[EBudgetGridOptions.PREVIEW] ||
        selectedAction === EBudgetGridOptionsValues[EBudgetGridOptions.PREINVOICE] ||
        selectedAction === EBudgetGridOptionsValues[EBudgetGridOptions.ORDERS];

    return (
        <div className={classNames("flex flex-column viewContainer", { "px-4 budget-view-container": !usesNovarium })}>
            {(selectedAction !== EBudgetGridOptionsValues[EBudgetGridOptions.PREVIEW] &&
                selectedAction !== EBudgetGridOptionsValues[EBudgetGridOptions.PREINVOICE] &&
                selectedAction !== EBudgetGridOptionsValues[EBudgetGridOptions.ORDERS]) &&
                <React.Fragment>
                    {/* El alta y la edición tienen su propio encabezado (« Volver + título), según el design system. */}
                    {!showCRUBudget && (
                        <React.Fragment>
                            <div className="flex md:gap-4 gap-2 align-items-end flex-column md:flex-row">
                                <h2 className="text-2xl mainTitle">Facturación sanatorial</h2>
                            </div>
                            <div className="flex justify-content-between">
                                <ul className="p-0 m-0 list-none flex overflow-x-auto select-none">
                                    <li style={{ backgroundColor: '#f9fafb' }}>
                                        <a className={classNames('p-ripple cursor-pointer px-4 py-3 flex align-items-center border-bottom-2 hover:border-500 transition-colors transition-duration-150 border-noround', { 'tabComponent': tabIndex === 2, ' text-700 border-transparent': tabIndex !== 2 })} onClick={() => setTabIndex(2)}>
                                            <span className="font-medium" style={{ color: (tabIndex === 2) ? '#01717C' : '#1C2E4599' }}>{intl.formatMessage({ id: 'Historic' })}</span>
                                        </a>
                                    </li>
                                </ul>
                                {showNewBudgetButton && (
                                    <Button
                                        className="buttonMain"
                                        label={intl.formatMessage({ id: 'CreateNew' })}
                                        onClick={() => {
                                            setSelectedBudget({ ...defaultBudgetDTO, professionalActivities: [], disposables: [], equipments: [], nutritionalSupportItems: [], medicines: [], extras: [] });
                                            setSelectedAction(EBudgetGridOptionsValues[EBudgetGridOptions.CREATE]);
                                        }}
                                    />
                                )}
                            </div>

                            <div className="p-mb-2 p-mt-2" style={{ background: 'rgba(26, 56, 96, 0.1)', height: '1px', marginBottom: '13px' }}></div>
                        </React.Fragment>
                    )}

                    {tabIndex === 1 && <CRUHospitalizationBillView budget={selectedBudget} hideView={onCloseCRUBudgetView} />}
                    {tabIndex === 2 && (
                        <HistoricBillHospitalizationView
                            selectedAction={selectedAction}
                            setSelectedAction={setSelectedAction}
                            setSelectedBudget={setSelectedBudget}
                            setOpenPrintBudgetModal={setOpenPrintBudgetModal}
                        />
                    )}
                </React.Fragment>
            }
            {selectedAction === EBudgetGridOptionsValues[EBudgetGridOptions.PREVIEW] && (
                <BillHospitalizationPreview setSelectedAction={setSelectedAction} selectedBudget={selectedBudget} setSelectedBudget={setSelectedBudget} setOpenPrintBudgetModal={setOpenPrintBudgetModal} />
            )}
            {selectedAction === EBudgetGridOptionsValues[EBudgetGridOptions.PREINVOICE] && (
                <PreinvoiceFromBillHospitalizationView
                    budget={selectedBudget}
                    hideView={onCloseCRUBudgetView}
                    setSelectedAction={setSelectedAction}
                    // Después de generar se muestran las órdenes que se crearon
                    onGenerated={() => setSelectedAction(EBudgetGridOptionsValues[EBudgetGridOptions.ORDERS])}
                />
            )}
            {selectedAction === EBudgetGridOptionsValues[EBudgetGridOptions.ORDERS] && selectedBudget.budget != null && (
                <BillHospitalizationOrdersView budgetId={selectedBudget.budget} onBack={onCloseCRUBudgetView} />
            )}
            <PrintBillHospitalizationModal
                budget={selectedBudget.budget ?? 0}
                // Prefacturada: el PDF sale de las órdenes, con todos los ítems sin dividir por pagador
                preinvoiced={selectedBudget.budgetstate === 6}
                openPrintBudgetModal={openPrintBudgetModal}
                setOpenPrintBudgetModal={setOpenPrintBudgetModal}
            />
        </div>
    );
}
